export default __webpack_public_path__ + "static/media/xx.4dcbc38e.svg";